// src/components/ConsultationForm/ClinicalProficiencySection.js
import React from 'react';
import { Form, ToggleButton } from 'react-bootstrap';

const ClinicalProficiencySection = ({ formData, onChange }) => {
  const proficiencyOptions = [
    { value: 'Pediatric Anesthesia', label: 'Pediatric Anesthesia' },
    { value: 'Cardiac Anesthesia', label: 'Cardiac Anesthesia' },
    { value: 'Neuroanesthesia', label: 'Neuroanesthesia' },
    { value: 'Obstetric Anesthesia', label: 'Obstetric Anesthesia' },
    { value: 'Regional Anesthesia', label: 'Regional Anesthesia' },
  ];

  const emrOptions = [
    { value: 'Epic', label: 'Epic' },
    { value: 'Cerner', label: 'Cerner' },
    { value: 'Meditech', label: 'Meditech' },
    { value: 'Allscripts', label: 'Allscripts' },
    { value: 'Other', label: 'Other' },
  ];

  // Helper function to render a group of toggle buttons
  const renderToggleButtonGroup = (
    name,
    groupLabel,
    options,
    selectedValues,
    infoText = '',
    inputType = 'checkbox',
    styleOverride = { minWidth: '140px' },
    variant = 'outline-secondary'
  ) => (
    <Form.Group controlId={name} className="mb-4">
      <Form.Label className="h6" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
        {groupLabel}
      </Form.Label>
      <div className="d-flex flex-wrap">
        {options.map((option, idx) => {
          const uniqueId = `${name}_${option.value}_${idx}`;
          const checked =
            inputType === 'radio'
              ? selectedValues === option.value
              : (selectedValues || []).includes(option.value);
          return (
            <ToggleButton
              key={uniqueId}
              id={uniqueId}
              type={inputType}
              variant={variant}
              name={name}
              value={option.value}
              checked={checked}
              onChange={onChange}
              className="m-1"
              style={styleOverride}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </div>
      {infoText && <Form.Text className="text-muted">{infoText}</Form.Text>}
    </Form.Group>
  );

  return (
    <>
      {renderToggleButtonGroup(
        'areasOfProficiency',
        'Areas of Proficiency',
        proficiencyOptions,
        formData.areasOfProficiency,
        ''
      )}
      {renderToggleButtonGroup(
        'emrExperience',
        'EMR Experience',
        emrOptions,
        formData.emrExperience,
        'Select your EMR systems. Selecting "Other" will simply register as "Other".'
      )}
    </>
  );
};

export default ClinicalProficiencySection;
